import React from 'react';
import PropTypes from 'prop-types';

export const teamsByDivisionListPropTypes = {
    division: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        teams: PropTypes.array
    }),
    listType: PropTypes.string
};